import classNames from 'classnames'
import { ReactComponent as Spinner } from '../assets/icons/loader.svg'

const setClassName = ({ className, size }: { className?: string; size?: string }) => classNames(className, { [size || '']: size })

const Loader = ({ className, size = 'medium', ...props }: { className?: string; size?: string; style?: any }) => (
  <Spinner className={setClassName({ className, size })} {...props} />
)

export default Loader
